<template>
  <wb-360-viewer
    class="otb-vehicle-viewer"
    preload-high-res-images
    ref="viewerElement"
    :class="viewerClasses"
    :current-index="4"
  >
    <img
      class="otb-vehicle-viewer-indicator otb-vehicle-viewer-desktop"
      :src="require(`../../assets/360-desktop.svg`)"
    />
    <img
      class="otb-vehicle-viewer-indicator otb-vehicle-viewer-mobile"
      :src="require(`../../assets/360-mobile.svg`)"
    />
  </wb-360-viewer>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue';

import { Image } from '../../models/utilities/images.model';
import Viewer360Service from '../../services/viewer360.service';

export default defineComponent({
  name: 'otb-viewer-360-image',
  props: {
    show: Boolean,
    src: Object as () => Image,
  },
  setup(props, { emit }) {
    let viewerElement = ref({} as { images: any; currentIndex: any });

    const viewerClasses = computed(() => {
      return {
        'otb-hide': !props.show,
      };
    });

    const updateViewer = () => {
      if (
        props.src &&
        props.src.defaultImage &&
        Viewer360Service.is360Image(props.src.defaultImage)
      ) {
        const resUrls = Viewer360Service.getResUrls(
          (props.src as Image).defaultImage
        );
        if (viewerElement.value) {
          viewerElement.value.images =
            Viewer360Service.get360ImagesArray(resUrls);
          viewerElement.value.currentIndex = 4;
        }
      }
    };

    watch(
      () => props.src,
      () => {
        emit('srcChange');
        updateViewer();
      }
    );

    onMounted(() => {
      updateViewer();
    });
    return { viewerClasses, viewerElement };
  },
});
</script>

<style scoped src="./viewer-360-image.scss" lang="scss"></style>
